export const STARTING_SIDE_OPTIONS = [
  { value: 'unknown', label: 'Not sure' },
  { value: 'left', label: 'Defending the left goal' },
  { value: 'right', label: 'Defending the right goal' }
]
